import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";

// Limitless Imports
import { withi18n } from "../../../../../customer/components";
import SearchInput from "@limitless/modern/inputs/search-input/SearchInput";
import DataTable from "@limitless/modern/data-display/table/DataTable.js";
import { renderValueCell } from "../../../../utils/table-cell-renderers/TableCellRenderers";
const ExtraInfoTableView = ({
  classes,
  t,
  finalData,
  onFilterData
}) => {
  const [searchValue, setSearchValue] = React.useState("");
  const handleSearchData = () => {
    onFilterData({
      searchKey: searchValue
    });
  };
  const handleClearSearch = () => {
    setSearchValue("");
    onFilterData({
      searchKey: ""
    });
  };
  const columns = [{
    name: "category",
    label: "Category",
    options: {
      sort: false
    }
  }, {
    name: "attribute",
    label: "Name",
    options: {
      sort: false
    }
  }, {
    name: "value",
    label: "Value(click to copy)",
    options: {
      sort: false,
      customBodyRender: v => renderValueCell(v, t("value")),
      setCellProps: () => {
        return {
          style: {
            maxWidth: 120
          }
        };
      }
    }
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.extraInfoContainer
  }, /*#__PURE__*/React.createElement(SearchInput, {
    placeholder: "Type here",
    label: "Search",
    id: "extraInfoSearchInput",
    value: searchValue || "",
    clearSearch: handleClearSearch,
    onSubmit: handleSearchData,
    onChange: value => setSearchValue(value)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.tableWrapper
  }, /*#__PURE__*/React.createElement(DataTable, {
    columns: columns,
    data: finalData
  })));
};
const styles = theme => ({
  extraInfoContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    marginTop: 24,
    marginRight: 16
  },
  tableWrapper: {
    border: theme.palette.border,
    borderRadius: 4,
    marginTop: 24
  }
});
export default withStyles(styles)(withi18n(ExtraInfoTableView));
ExtraInfoTableView.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  finalData: PropTypes.array.isRequired,
  updateInfoCriteria: PropTypes.func.isRequired,
  onValueCopied: PropTypes.func.isRequired,
  onFilterData: PropTypes.func.isRequired,
  clearFilterData: PropTypes.func.isRequired,
  onUpdateSelectedItem: PropTypes.func.isRequired,
  searchKey: PropTypes.string.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  copiedKey: PropTypes.string.isRequired
};